import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../../components";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { _SAVE_USER_ROLE } from "../../../models/rbacModel";
import { formToObject } from "../../../utils";

const AddRoleFormComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _SAVE_USER_ROLE(formToObject(form)).then((res) => {
      if (res.status == "1") {
        form.reset();
        context.setAlertMsg(res.message || "Saved");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Save",
        });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          <Row>
            <Col md={3}>
              <PsLabel text="Role" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="role_name"
                placeholder="Role"
                size="sm"
                className="fw-bold"
                autoFocus
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Order" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="number"
                name="display_order"
                size="sm"
                className="fw-bold"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Status" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="select"
                name="active_status"
                size="sm"
                className="fw-bold form-select form-select-sm"
                required
              >
                <option value="1">Active</option>
                <option value="0">In-Active</option>
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const AddRoleForm = (props) => {
  return (
    <>
      <PsModalWindow size="sm" title="Add Role" {...props}>
        {props.show && <AddRoleFormComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default AddRoleForm;
